
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/adm",
      function () {
        return require("private-next-pages/adm/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/adm"])
      });
    }
  